import { ConnectedButtonGroup } from "../ConnectedButtonGroup";
import type { QuickStudyTab } from "./types";

type Props = {
	value: QuickStudyTab;
	onChange: (tab: QuickStudyTab) => void;
	recommendedLabel: string;
	customLabel: string;
};

const TABS: {
	key: QuickStudyTab;
	labelKey: "recommendedLabel" | "customLabel";
}[] = [
	{ key: "recommended", labelKey: "recommendedLabel" },
	{ key: "custom", labelKey: "customLabel" },
];

const QuickStudyTabs = ({
	value,
	onChange,
	recommendedLabel,
	customLabel,
}: Props) => {
	const labels = { recommendedLabel, customLabel };
	return (
		<ConnectedButtonGroup
			buttons={TABS.map(({ key, labelKey }) => ({
				value: key,
				label: labels[labelKey],
			}))}
			value={value}
			onValueChange={(value) => onChange(value as QuickStudyTab)}
			showSelectedCheck={false}
		/>
	);
};

export default QuickStudyTabs;
